
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PersonSubscriptionSettingsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewPerson"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"goToHouse"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"goToHouseKm"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"city"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PersonCityFragment"},"directives":[]}]}},{"kind":"Field","alias":{"kind":"Name","value":"professions"},"name":{"kind":"Name","value":"actualPersonProfessions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PersonProfessionFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"zones"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PersonZoneFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"services"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PersonServiceFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"zoneWaitingListSubscriptions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ZoneWaitingListSubscriptionFragment"},"directives":[]}]}}]}}],"loc":{"start":0,"end":695}};
    doc.loc.source = {"body":"#import \"~/graphql/fragments/personCityFragment.graphql\"\n#import \"~/graphql/fragments/personProfessionFragment.graphql\"\n#import \"~/graphql/fragments/personZoneFragment.graphql\"\n#import \"~/graphql/fragments/personServiceFragment.graphql\"\n#import \"~/graphql/fragments/zoneWaitingListSubscriptionFragment.graphql\"\n\nfragment PersonSubscriptionSettingsFragment on NewPerson {\n  paymentType\n  goToHouse\n  goToHouseKm\n  city {\n    ...PersonCityFragment\n  }\n  professions: actualPersonProfessions {\n    ...PersonProfessionFragment\n  }\n  zones {\n    ...PersonZoneFragment\n  }\n  services {\n    ...PersonServiceFragment\n  }\n  zoneWaitingListSubscriptions {\n    ...ZoneWaitingListSubscriptionFragment\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("~/graphql/fragments/personCityFragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("~/graphql/fragments/personProfessionFragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("~/graphql/fragments/personZoneFragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("~/graphql/fragments/personServiceFragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("~/graphql/fragments/zoneWaitingListSubscriptionFragment.graphql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["PersonSubscriptionSettingsFragment"] = oneQuery(doc, "PersonSubscriptionSettingsFragment");
        
